/**
 * Created by mathieudeumie on 30/04/2014.
 */

angular.module('FlexyBeautyApp.controllers').controller('AppConfigCtrl', ["$scope", "App", "AppSrv", "AppData", "AppAttribute", "$location",
    function ($scope, App, AppSrv, AppData, AppAttribute, $location) {
        $scope.dd =
            {
                appList: [],
                newAppCode: "",
                newAppCreating: null,
                newAppAttribute: {
                    code: "",
                    value: "",
                    text: ""
                },
                edited: null,
                once: 0
            };

        $scope.$watch('ad.dataLoaded', function (newValue, oldValue) {
            if (newValue) {
                $scope.dd.appList = AppData.getAppList();
            }
        });

        $scope.createApp = function (appCode) {
            var newApp = new App();
            newApp.setCode(appCode);

            return newApp;
        };
        $scope.addAttribute = function () {
            var newAppAttribute;
            if ($scope.dd.newAppCode && !$scope.dd.newAppCreating && !$scope.dd.edited) {
                // New app not yet saved
                $scope.dd.newAppCreating = $scope.createApp($scope.dd.newAppCode);
                if ($scope.dd.newAppAttribute.code !== "" && ($scope.dd.newAppAttribute.value !== "" || $scope.dd.newAppAttribute.text !== "")) {
                    newAppAttribute = new AppAttribute($scope.dd.newAppAttribute.code, $scope.dd.newAppAttribute.value, $scope.dd.newAppAttribute.text);
                    $scope.dd.newAppCreating.addAppAttribute(newAppAttribute);
                }
                $scope.dd.newAppAttribute.code = "";
                $scope.dd.newAppAttribute.value = "";
                $scope.dd.newAppAttribute.text = "";
            } else if ($scope.dd.newAppCreating && !$scope.dd.edited) {
                // New app instanciated (if attribute allready added by example) but not yet saved
                if ($scope.dd.newAppAttribute.code !== "" && ($scope.dd.newAppAttribute.value !== "" || $scope.dd.newAppAttribute.text !== "")) {
                    newAppAttribute = new AppAttribute($scope.dd.newAppAttribute.code, $scope.dd.newAppAttribute.value, $scope.dd.newAppAttribute.text);
                    $scope.dd.newAppCreating.addAppAttribute(newAppAttribute);
                }
                $scope.dd.newAppAttribute.code = "";
                $scope.dd.newAppAttribute.value = "";
                $scope.dd.newAppAttribute.text = "";
            } else if ($scope.dd.edited) {
                // app existing and now being edited
                if ($scope.dd.newAppAttribute.code !== "" && ($scope.dd.newAppAttribute.value !== "" || $scope.dd.newAppAttribute.text !== "")) {
                    newAppAttribute = new AppAttribute($scope.dd.newAppAttribute.code, $scope.dd.newAppAttribute.value, $scope.dd.newAppAttribute.text);
                    $scope.dd.edited.addAppAttribute(newAppAttribute);
                }
                $scope.dd.newAppAttribute.code = "";
                $scope.dd.newAppAttribute.value = "";
                $scope.dd.newAppAttribute.text = "";
            }

        };
        $scope.removeAttribute = function (app, appAttribute) {
            app.removeAppAttribute(appAttribute);
        };
        $scope.saveApp = function () {
            if ($scope.dd.newAppCreating)
                AppSrv.save($scope.dd.newAppCreating);
            else if ($scope.dd.edited)
                AppSrv.save($scope.dd.edited);
            else if ($scope.dd.newAppCode) {
                var newApp = new App();
                newApp.setCode($scope.dd.newAppCode);
                AppSrv.save(newApp);
            }

            $scope.dd.newAppCode = "";
            $scope.dd.newAppAttribute.code = "";
            $scope.dd.newAppAttribute.value = "";
            $scope.dd.newAppCreating = null;
            $scope.dd.edited = null;
        };
        $scope.removeApp = function (app) {
            AppSrv.remove(app);
        };
        $scope.setEditedApp = function (app) {
            $scope.dd.edited = app;
        };
        $scope.reload = function () {
            $location.path();
        };
    }
]);



// WEBPACK FOOTER //
// ./js/controllers/pro/configuration/AppConfigCtrl.js